/**
 * Plataformas hidden (shared/ad_platforms.json).
 * Não mostrar no seletor, sidebar, planos.allowed efetivo nem cards de conta.
 * Manter alinhado ao catálogo — visibility=hidden.
 */
export const HIDDEN_AD_PLATFORM_SLUGS = new Set([
  "amazon_ads",
  "amazon",
  "amazon ads",
  "amazon_sp",
  "amazon_dsp",
  "amazon dsp",
  "x_ads",
  "twitter",
  "twitter_ads",
  "x ads",
  "pinterest_ads",
  "pinterest",
  "pinterest ads",
  "snapchat_ads",
  "snap",
  "snapchat",
  "snap ads",
  "reddit_ads",
  "reddit",
  "reddit ads",
  "kwai_ads",
  "kwai",
  "kwai ads",
  "apple_search_ads",
  "asa",
  "apple ads",
  "shopee_ads",
  "shopee",
  "magalu_ads",
  "magazine_luiza_ads",
  "magalu",
  "walmart_connect",
  "walmart_ads",
  "walmart",
  "criteo_retail",
  "criteo",
  "criteo_ads",
  "dv360",
  "display_video_360",
  "dv_360",
  "the_trade_desk",
  "ttd",
  "tradedesk",
  "taboola",
  "taboola_ads",
  "outbrain",
  "outbrain_ads",
  "twitch_ads",
  "twitch",
  "roku_ads",
  "roku",
  "roku_oneview",
  "unity_ads",
  "unity",
  "quora_ads",
  "quora",
  "yahoo_dsp",
  "yahoo_ads",
  "verizon_dsp",
  "netflix_ads",
  "netflix",
  "instacart_ads",
  "instacart",
  "line_ads",
  "line",
  "applovin_ads",
  "applovin",
  "max",
  "yandex_direct",
  "yandex",
  "yandex_ads",
  "naver_ads",
  "naver",
  "tencent_ads",
  "wechat_ads",
  "gdt",
  "telegram_ads",
  "telegram",
  "threads_ads",
  "threads",
]);

export function normalizeAdPlatform(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
}

export function isHiddenAdPlatform(value) {
  const raw = String(value || "").trim().toLowerCase();
  const norm = normalizeAdPlatform(value);
  return HIDDEN_AD_PLATFORM_SLUGS.has(raw) || HIDDEN_AD_PLATFORM_SLUGS.has(norm);
}

export function filterPublicAdAccounts(rows) {
  return (rows || []).filter((row) => {
    const plataform = row?.plataform || row?.platform || "";
    return !isHiddenAdPlatform(plataform);
  });
}

export function filterPublicPlatformSlugs(slugs) {
  return (slugs || []).filter((slug) => !isHiddenAdPlatform(slug));
}
